<script >
import Modal from './modal.vue';
import StockForm from './stock-form.vue';

// 说明：该组件仅负责 PC 端弹窗展示，表单内容复用 stock-form.vue（不包含弹窗/Popup 逻辑）
const __sfc_main = {};
__sfc_main.props = {
  // 当前操作的场次（用于展示当前价格等）
  session: {
    type: Object,
    default: null
  },
  // 当前用户记录（用于回填）
  record: {
    type: Object,
    default: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const props = __props;
  return {
    emit,
    props
  };
};
__sfc_main.components = Object.assign({
  Modal,
  StockForm
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
    <Modal class="stock-form-modal is-pc" @close="emit('close')">
        <StockForm
            :session="props.session"
            :record="props.record"
            @submit="(data) => emit('submit', data)"
        />
    </Modal>
</template>

<style lang="less">
.stock-form-modal {
    .act-modal-wrapper {
        width: 7.5rem;
    }
    .act-modal-content {
        border-radius: .3rem;
        overflow: hidden;
        background: #fff;
    }

    ._common-guess_stock-form {
        padding: .36rem .36rem .3rem;

        // .reason-textarea {}
        .submit-btn {
            margin-top: .3rem;
            width: 3.7rem;
            height: .7rem;
        }
    }
}
</style>


